
import { POS_FRONTEND_BUILD_INFO } from "../common/buildInfo";

const baseApi = process.env.REACT_APP_API_URL;

const defaultHeaders = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'X-POS-Frontend-Version': POS_FRONTEND_BUILD_INFO.version,
    'X-POS-Frontend-Build': POS_FRONTEND_BUILD_INFO.marker,
};

export const request = {
    get: async (url: string, params?: Record<string, any>) => {
        const queryParams = params ? `?${new URLSearchParams(params)}` : '';
        return (await fetch(`${baseApi}${url}${queryParams}`, {
            headers: defaultHeaders,
        })).json()
    },
    post: async (url: string, body: any) => (await fetch(`${baseApi}${url}`, {
        method: 'POST',
        headers: defaultHeaders,
        body: JSON.stringify(body)
    })).json(),
    put: async (url: string, body?: any) => (await fetch(`${baseApi}${url}`, {
        method: 'PUT',
        headers: defaultHeaders,
        body: body ? JSON.stringify(body) : undefined
    })).json(),
}

// ---------------------------------------------------------------------------
// Peticiones autenticadas (rutas `spa.auth` del back, p. ej. el tablero de
// domicilios). Mandan el token de la sesión del POS (`pos-user.token`, el mismo
// que el back guarda en token_session) y siempre regresan {success, message,
// object, status}, también cuando el back responde 401/403/422 sin `success`.
// ---------------------------------------------------------------------------
export const posToken = (): string => {
    try {
        return JSON.parse(localStorage.getItem(`${process.env.REACT_APP_PREFIX_STORAGE}user`) ?? 'null')?.token ?? '';
    } catch (e) {
        return '';
    }
};

const authHeaders = () => {
    const token = posToken();
    return token ? { ...defaultHeaders, Authorization: `Bearer ${token}` } : { ...defaultHeaders };
};

const parseResponse = async (response: Response) => {
    let body: any = null;
    try {
        body = await response.json();
    } catch (e) {
        body = null;
    }
    if (body && typeof body === 'object' && 'success' in body) {
        return { ...body, status: response.status };
    }
    return {
        success: response.ok,
        message: body?.message ?? (response.ok ? '' : `Error ${response.status}`),
        object: body?.object ?? body ?? null,
        status: response.status,
    };
};

export const authRequest = {
    get: async (url: string, params?: Record<string, any>) => {
        const queryParams = params ? `?${new URLSearchParams(params)}` : '';
        return parseResponse(await fetch(`${baseApi}${url}${queryParams}`, { headers: authHeaders() }));
    },
    post: async (url: string, body?: any) => parseResponse(await fetch(`${baseApi}${url}`, {
        method: 'POST',
        headers: authHeaders(),
        body: body ? JSON.stringify(body) : undefined,
    })),
}
